<template>
  <div class="home">
    <Placement msg="Растановка механизмов по причалам" />
  </div>
</template>

<script>
// @ is an alias to /src
import Placement from "@/components/Placement.vue";

export default {
  name: "Home",
  components: {
    Placement,
  },
};
</script>
